import * as React from 'react';
import cn from 'clsx';
import { UIText3 } from '@cian/ui-kit';

import blankIcon from '../../../../static/blank.svg';

import * as styles from './styles.css';

interface IAdditionalServiceBadgeProps {
  className?: string;
  badge: string;
}

export const AdditionalServiceBadge: React.FC<React.PropsWithChildren<IAdditionalServiceBadgeProps>> = ({
  className,
  badge,
}) => {
  return (
    <span className={cn(styles['badge'], className)}>
      <img src={blankIcon} width="16" height="16" alt="" />
      <UIText3>{badge}</UIText3>
    </span>
  );
};
